import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "./TestCards.css";
import personality from "../../../img/test-images/personality.svg"
import emotional from "../../../img/test-images/emotional.svg"
import selfesteem from "../../../img/test-images/self-esteem.svg"
import stressscale from "../../../img/test-images/stress-scale.svg"
// import generalhealth from "../../../img/test-images/general-health.svg"

function CreateCard(props) {
  return (
    <Col sm={6} md={4}>
      <div className="testcard">
        <div>
          <img className="test-img" src={props.src} alt=""/>
        </div>
        <div className="test-name">
          <p>{props.title}</p>
        </div>
        <div className="card-bottom">
          <Button href={props.route} variant="outline-dark">Take Test</Button>
        </div>
      </div>
    </Col>
  );
}

function TestCards() {
  return (
    <Container className="selftest-container">
      <p className="selftest-heading">
        Choose a test to explore and learn more about yourself
      </p>
      <Row>
        <CreateCard title="Personality Assessment" src={personality} route="/selfevaluation/personality-assessment" />
        <CreateCard title="Emotional Intelligence" src={emotional} route="/selfevaluation/emotional-intelligence" />
        <CreateCard title="Self-Esteem" src={selfesteem} route="/selfevaluation/self-esteem" />
        <CreateCard title="Stress Scale" src={stressscale} route="/selfevaluation/stress-scale"/>
        {/* <CreateCard title="General Health" src={generalhealth} route="/selfevaluation/general-health"/> */}
      </Row>
    </Container>
  );
}

export { TestCards };
